import { Link } from "react-router-dom";
import { useLang, useT, useLangPath } from "@/i18n";

/** Linkurile către paginile legale, folosite în toate footerele.
 *
 *  Duce limba curentă în starea rutei, fiindcă /privacy și /terms nu au prefix
 *  de limbă și n-ar avea de unde s-o afle. Cine ajunge direct pe ele, dintr-un
 *  link extern, nu are limbă de dus — și atunci nota nu apare, corect: nu
 *  există nimic de explicat cuiva care n-a citit site-ul în altă limbă. */
export default function LegalLinks() {
  const t = useT();
  const lang = useLang();
  const lp = useLangPath();
  return (
    <span className="legalinks">
      {/* „Despre" stă aici, nu în bara de sus: bara are cinci intrări și e
          echilibrată așa, iar un studio nu se vinde cu pagina despre el. Dar
          trebuie să existe un drum spre ea din fiecare pagină — altfel e
          orfană, ajunsă doar din sitemap. */}
      <Link to={lp("/about")}>{t.about.title}</Link>
      {/* Indexul de nișe, din același motiv și la o scară mult mai mare: 162 de
          pagini ajunse doar din sitemap. Linkul ăsta e singura lor legătură cu
          restul site-ului, deci stă în subsol, adică pe fiecare pagină. */}
      <Link to={lp("/industries")}>{t.industriesPage.short}</Link>
      <Link to="/privacy" state={{ from: lang }}>{t.footer.privacy}</Link>
      <Link to="/terms" state={{ from: lang }}>{t.footer.terms}</Link>
    </span>
  );
}
